import * as React from 'react'
import MuiContainer from '@mui/material/Container'
import { ContainerProps } from '@mui/material'

export function Container(props?: ContainerProps) {
  return <MuiContainer {...props}>{props.children}</MuiContainer>
}
